import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { CandidateFilterMatchMode } from 'modules/candidate-profile/types/CandidateSearchFilter';
import { candidateFilterSx } from 'modules/candidate-profile/styles/candidateFilterSx';

const MODE_LABELS: Record<CandidateFilterMatchMode, string> = {
  [CandidateFilterMatchMode.INCLUDE_ANY]: 'Include any',
  [CandidateFilterMatchMode.INCLUDE_ALL]: 'Include all',
  [CandidateFilterMatchMode.EXCLUDE]: 'Exclude'
};

const MODES = [
  CandidateFilterMatchMode.INCLUDE_ANY,
  CandidateFilterMatchMode.INCLUDE_ALL,
  CandidateFilterMatchMode.EXCLUDE
];

type CandidateFilterMatchModeToggleProps = {
  value: CandidateFilterMatchMode;
  onChange: (mode: CandidateFilterMatchMode) => void;
  disabled?: boolean;
};

export const CandidateFilterMatchModeToggle: React.FC<
  CandidateFilterMatchModeToggleProps
> = ({ value, onChange, disabled = false }) => (
  <ToggleButtonGroup
    exclusive
    value={value}
    disabled={disabled}
    aria-label="Match mode"
    onChange={(_, mode: CandidateFilterMatchMode | null) => {
      // MUI emits null when the active button is re-clicked; there is no
      // unselected state.
      if (mode) onChange(mode);
    }}
    sx={candidateFilterSx.matchModeToggleGroup}
  >
    {MODES.map((mode, index) => (
      <ToggleButton
        key={mode}
        value={mode}
        aria-label={MODE_LABELS[mode]}
        sx={candidateFilterSx.matchModeToggleButton(
          index === 0,
          index === MODES.length - 1
        )}
      >
        {MODE_LABELS[mode]}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
